export default __webpack_public_path__ + "media/images/mastheads/dmac-masthead-04eee55d10856cdf766e75694f52bf21.jpg";